/**
 * LiveKit Cloud Configuration
 * Simple configuration for LiveKit Cloud video streaming
 */
export class LiveKitConfig {
  // LiveKit Cloud Configuration
  static readonly LIVEKIT_URL = import.meta.env.VITE_LIVEKIT_URL || '';
  static readonly LIVEKIT_API_KEY = import.meta.env.VITE_LIVEKIT_API_KEY || '';
  static readonly LIVEKIT_API_SECRET = import.meta.env.VITE_LIVEKIT_API_SECRET || '';

  /**
   * Get the LiveKit URL
   */
  static getLiveKitUrl(): string {
    return this.LIVEKIT_URL;
  }

  /**
   * Get the API key
   */
  static getApiKey(): string {
    return this.LIVEKIT_API_KEY;
  }

  /**
   * Get the API secret
   */
  static getApiSecret(): string {
    return this.LIVEKIT_API_SECRET;
  }

  /**
   * Validate configuration
   */
  static validateConfig(): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];

    if (!this.LIVEKIT_URL) {
      errors.push('VITE_LIVEKIT_URL is required');
    }

    if (!this.LIVEKIT_API_KEY) {
      errors.push('VITE_LIVEKIT_API_KEY is required');
    }

    if (!this.LIVEKIT_API_SECRET) {
      errors.push('VITE_LIVEKIT_API_SECRET is required');
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }

  /**
   * Get configuration object
   */
  static getConfig() {
    return {
      url: this.LIVEKIT_URL,
      apiKey: this.LIVEKIT_API_KEY,
      apiSecret: this.LIVEKIT_API_SECRET,
    };
  }
}
